import React from "react";
import "./App.css";
import { BrowserRouter, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AdminWrapper from "./component/layout/AdminWrapper";
import GlobalWhatsAppChat from "./component/GlobalWhatsAppChat";
import ScrollToTop from "./helpers/ScrollToTop";
import { Helmet, HelmetProvider } from "react-helmet-async";

const SITE_URL = "https://www.suraksha24x7.com";

function SiteMetadata() {
  const location = useLocation();
  const pathname = location.pathname || "/";
  const canonicalUrl = `${SITE_URL}${pathname === "/" ? "/" : pathname}`;

  return (
    <Helmet>
      <title>Suraksha 24X7 | CCTV & Security Systems in Delhi NCR</title>
      <meta
        name="description"
        content="Suraksha 24X7 provides CCTV camera installation, access control, biometric systems and smart security solutions across Delhi NCR."
      />
      <meta
        name="keywords"
        content="CCTV installation Delhi NCR, access control system, biometric attendance, security camera dealer, surveillance solutions, Suraksha 24X7"
      />
      <meta property="og:type" content="website" />
      <meta property="og:site_name" content="Suraksha 24X7" />
      <meta
        property="og:title"
        content="Suraksha 24X7 | CCTV & Security Systems in Delhi NCR"
      />
      <meta
        property="og:description"
        content="CCTV camera installation, access control, biometric, video door phone and smart security solutions for homes, offices and commercial sites in Delhi NCR."
      />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={`${SITE_URL}/logo.jpeg`} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta
        name="twitter:title"
        content="Suraksha 24X7 | CCTV & Security Systems in Delhi NCR"
      />
      <meta
        name="twitter:description"
        content="Smart security systems and CCTV installation solutions in Delhi NCR."
      />
      <meta name="twitter:image" content={`${SITE_URL}/logo.jpeg`} />
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
}

function App() {
  return (
    <>
      <HelmetProvider>
        <BrowserRouter>
          <ScrollToTop />
          <SiteMetadata />
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop={true}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="dark"
          />

          <AdminWrapper />
          <GlobalWhatsAppChat />
        </BrowserRouter>
      </HelmetProvider>
    </>
  );
}

export default App;
